<template>
    <div class="bg-about">
        <div class="demo-product-section pt-100 pb-70">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-lg-6 pb-30">
                        <div class="about-section-item about-item-details desk-pad-right-70">
                            <div class="section-title section-title-left text-start mb-0">
                                <h2>{{ $t('aboutUs.team.title') }}</h2>
                                <p class="text">
                                    {{ $t('aboutUs.team.description') }}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 pb-30">
                        <div class="about-section-item about-item-image text-center ">
                            <img v-lazy="$ossImg('about/about-2.jpg')" alt="shape">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="demo-product-section pt-100">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-lg-6 pb-30">
                        <div class="about-section-item about-item-image text-center desk-pad-right-70">
                            <img v-lazy="$ossImg('about/about-1.jpg')" alt="shape">
                        </div>
                    </div>
                    <div class="col-lg-6 pb-30">
                        <div class="about-section-item about-item-details">
                            <div class="section-title section-title-left text-start mb-0">
                                <h2>{{ $t('aboutUs.vision.title') }}</h2>
                                <p class="text">
                                    {{ $t('aboutUs.vision.description') }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'DemoProduct'
}
</script>
<style lang="css" scoped>
.text {
    color: #A3A3A3;
    text-align: justify;
    font-family: "Microsoft YaHei";
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 156%;
    /* 28.08px */

}

.bg-about {
    background: linear-gradient(48deg, #FDF8FF -17.75%, #EFF8FF 82.39%);
    transform: rotate(180deg);
    position: relative;
}

.bg-about>* {
    transform: rotate(-180deg);
}
</style>
